import Physics from "../components/Physics";
import C_Physics from "../../const/C_Physics";

class PhysicsSystem
{


    constructor()
    {
        this.app = PIXI.app;

        this.active = [];
        this.passive = [];
    }


    /**
     *
     * @param comp {Physics}
     */
    add(comp)
    {
        if (comp.physicsType == C_Physics.ACTIVE)
        {
            this.active.push(comp);
        }
        else if (comp.physicsType == C_Physics.PASSIVE)
        {
            this.passive.push(comp);
        }
    }


    /**
     *
     * @param comp {Physics}
     */
    remove(comp)
    {
        if (comp.physicsType == C_Physics.ACTIVE)
        {
            let idx = this.active.indexOf(comp);
            if (idx != -1)
            {
                this.active.splice(idx, 1);
            }
        }

        if (comp.physicsType == C_Physics.PASSIVE)
        {
            let idx = this.passive.indexOf(comp);
            if (idx != -1)
            {
                this.passive.splice(idx, 1);
            }
        }
    }


    run()
    {
        let numActive = this.active.length;
        let numPassive = this.passive.length;

        for (let activeIdx=0; activeIdx < numActive; activeIdx++)
        {
            let activeComp = this.active[activeIdx];

            if (!activeComp.physicsActive)
            {
                continue;
            }

            let activeCompPos = activeComp.position;
            let activeCompCollRadius = activeComp.collisionRadius;
            let activeCompVelocityScalar = activeComp.velocity.getLength();

            for (let passiveIdx=0; passiveIdx<numPassive; passiveIdx++)
            {
                let passiveComp = this.passive[passiveIdx];

                if (!passiveComp.physicsActive)
                {
                    continue;
                }

                let collisionDetected = false;

                let distance = passiveComp.position.distance(activeCompPos);

                if (distance < (activeCompCollRadius + passiveComp.collisionRadius))
                {
                    if (activeComp.lockedTarget)
                    {
                        if (activeComp.lockedTarget == passiveComp.getEntity())
                        {
                            collisionDetected = true;
                        }
                    }
                    else
                    {
                        collisionDetected = true;
                    }
                }
                else if (distance < activeCompVelocityScalar)
                {
                    let normalizedVel = activeComp.velocity.clone();
                    normalizedVel.normalize();

                    let targetVector = passiveComp.position.clone().subtract(activeCompPos);
                    targetVector.normalize();

                    let angle = Math.acos(normalizedVel.dotProduct(targetVector));

                    let intersectHeight = Math.sin(angle) * distance;

                    if (intersectHeight < passiveComp.collisionRadius)
                    {
                        if (activeComp.lockedTarget)
                        {
                            if (activeComp.lockedTarget == passiveComp.getEntity())
                            {
                                activeComp.velocity.normalize();
                                activeComp.velocity.scale(Math.cos(angle) * distance);
                                activeComp.position = activeComp.position.add(activeComp.velocity);
                                activeComp.position.z -= .5;
                                activeComp.velocity = passiveComp.velocity.clone();

                                collisionDetected = true;
                            }
                        }
                        else
                        {
                            activeComp.velocity.normalize();
                            activeComp.velocity.scale(Math.cos(angle) * distance);
                            activeComp.position = activeComp.position.add(activeComp.velocity);
                            activeComp.position.z -= .5;
                            activeComp.velocity = passiveComp.velocity.clone();

                            collisionDetected = true;
                        }
                    }
                }


                if (collisionDetected)
                {

                    passiveComp.collisions.push(activeComp.getEntity());
                    activeComp.collisions.push(passiveComp.getEntity());
                }
            }
        }
    }


}


export default PhysicsSystem;